module.exports = __webpack_public_path__ + "img/left-bottom.ade2edae.jpg";